import React, { useEffect, useState } from 'react'
import "./index.less"
import PageHead from '@/components/PageHead'
import SafetyWarning from '@/components/SafetyWarning'
import { useTranslation } from 'react-i18next'
import { Alert, Divider, Form, Input, message } from 'antd'
import { cdnUrl } from '@/utils/cdn'
import Loader from '@/components/Loader'
import BasicInfo from './compoenents/BasicInfo'
import { DEFAULT_RPC } from '@/config'
import { SuiClient } from '@mysten/sui/client';
import { formatUnits, parseUnits } from 'ethers'
import { useCurrentAccount, useSignAndExecuteTransaction } from '@mysten/dapp-kit'
import { Transaction } from "@mysten/sui/transactions";
export default function BurnToken() {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const account = useCurrentAccount();
  const [basicInfo, setBasicInfo] = useState<any>({});
  const [queringCoin, setQueringCoin] = useState(false)
  const coinType = Form.useWatch('coinType', form);
  const [burnAmount, setBurnAmount] = useState<any>();
  const { mutateAsync: signAndExecute } = useSignAndExecuteTransaction();
  const client = new SuiClient({
    url: DEFAULT_RPC,
  });
  console.log("coinType", coinType)
  function isValidCoinTypeFormat(s?: string): boolean {
    if (!s) return false;
    const COIN_TYPE_REGEX =
      /^0x[0-9a-fA-F]{1,64}::[A-Za-z_][A-Za-z0-9_]*::[A-Za-z_][A-Za-z0-9_]*$/;
    return COIN_TYPE_REGEX.test(s.trim());
  }
  console.log("coinType", coinType)
  async function getBasicInfo() {
    if (!account) {
      message.error("请先连接钱包")
      return
    }
    try {
      console.log("开始")
      setQueringCoin(true)
      const meta = await client.getCoinMetadata({ coinType });
      console.log("meta", meta)
      const totalSupply = await client.getTotalSupply({ coinType });
      const balance = await client.getBalance({
        owner: account.address,
        coinType,                // 要查的代币类型
      });
      setBasicInfo({
        ...meta,
        ...balance,
        totalSupply: formatUnits(totalSupply.value, meta?.decimals),
        totalBalance: formatUnits(balance.totalBalance, meta?.decimals)
      })
      console.log("totalSupply", totalSupply);
      console.log("meta", meta);
      console.log("balance", balance);
    } catch (error) {
      setBasicInfo({})
      // 查询失败
      message.error(t("tokenManagement.queryFailed"))
    } finally {
      setQueringCoin(false)
    }
  }
  const startBurn = async () => {
    if (!account) {
      message.error("请先连接钱包")
      return
    }
    if (Object.keys(basicInfo).length == 0) {
      message.error("请先选择代币")
    }
    console.log("burnAmount", burnAmount)
    const coinsRes = await client.getCoins({
      owner: account.address,
      coinType,                      // 比如 USDT 的 coinType
    });
    try {
      const tx = new Transaction();
      console.log("coinsRes", coinsRes)
      // const coinIds = coinsRes.data.map((c) => c.coinObjectId);
      // const [primaryId, ...restIds] = coinIds;
      // let primaryCoin = tx.object(primaryId);
      // console.log("primaryCoin", primaryCoin)
      // if (restIds.length > 0) {
      //   tx.mergeCoins(
      //     primaryCoin,
      //     restIds.map((id) => tx.object(id)),
      //   );
      // }

      // 2. 从合并后的 primaryCoin 里拆出要燃烧的数量
      // 注意：这里用的还是 primaryCoin 这个引用，TX 会自动把 merge 后的结果继续往下流
      // const [burnCoin] = tx.splitCoins(primaryCoin, [
      //   tx.pure.u64(parseUnits(burnAmount.toString(), basicInfo.decimals)), // burnAmount 是 BigInt，转成字符串
      // ]);
      // console.log("burnCoin", burnCoin)
      console.log("basicInfo.id", basicInfo.id)
      tx.moveCall({
        target: "0x2::coin_registry::burn",
        typeArguments: [coinType],
        arguments: [
          // tx.object("0xb77fd3240a3f95c13672974bb83f1634bcffc88d0db77dba3f071173d4edc3e9"),
          tx.object("0xb77fd3240a3f95c13672974bb83f1634bcffc88d0db77dba3f071173d4edc3e9"),
          tx.object("0x3cc4b2e1afefb30a775fd21bf1848315ec448b121be41c55154d072c38ac5fc7"),
        ],
      })
      const res = await signAndExecute({
        transaction: tx,
      });
      const ultimateRes = await client.waitForTransaction({
        digest: res.digest,
        options: {
          showEffects: true,
        },
        timeout: 60_000,
        pollInterval: 2_000,
      })
      const status = ultimateRes.effects?.status.status;
      const error = ultimateRes.effects?.status.error;
      console.log("ultimateResXXXX", ultimateRes)
      if (status !== 'success') {
        // 标记步骤失败
        // setStep3("error");
        // setStep4("waiting");
        // console.error(":", error);
        // 手动抛出异常，让外层 try/catch 能接到
        throw new Error(error);
      }
      message.success("燃烧成功")
    } catch (error) {
      console.log("燃烧失败error", error)
      message.success("燃烧失败")
    }
  }
  useEffect(() => {
    if (!coinType || !isValidCoinTypeFormat(coinType)) {
      setBasicInfo({});
      return;
    }
    const timer = setTimeout(() => {
      getBasicInfo();
    }, 500); // 500ms 防抖

    return () => clearTimeout(timer);
  }, [coinType])
  return (
    <div className='page-content burn-token-wrap'>
      <PageHead title={t("walletGenerator.title", { "chain": "SUI" })} desc={t("walletGenerator.desc", { "chain": "SUI" })} >
        <SafetyWarning />
      </PageHead>
      {/* 搜索代币 */}
      <div className='search-title'>{t("tokenManagement.searchToken")}</div>
      {/* <Form form={form}>
        <Form.Item name="coinType">
          <Input placeholder={t("tokenManagement.pleaseSearchTokenType")} suffix={queringCoin ? <Loader>
            <img src={cdnUrl("/img/loading-grey.webp")}></img>
          </Loader> : <></>}></Input>
        </Form.Item>
      </Form>
      <BasicInfo basicInfo={basicInfo} coinType={coinType} getBasicInfo={getBasicInfo} setBasicInfo={setBasicInfo}></BasicInfo> */}
      <Divider></Divider>
      <div>燃烧数量</div>
      <div className='input-section'>
        {/* 生成的钱包地址数量 */}
        <div className='title'>燃烧数量</div>
        <Input value={burnAmount} onChange={(e) => { setBurnAmount(e.target.value) }} suffix={<div className='input-btn'>
          <button onClick={() => { setBurnAmount(Number((basicInfo.totalBalance * 0.5).toFixed(5))) }}>50%</button>
          <button onClick={() => { setBurnAmount(Number(basicInfo.totalBalance)) }}>100%</button>
        </div>}></Input>
        {Object.keys(basicInfo).length > 0 && <div className='estimate'>
          <div className='conetnt'>预估燃烧后的流通总量：</div>
          <div className='value'>
            <div>{Number(basicInfo.totalSupply)}</div>
            <div>{basicInfo.symbol}</div>
          </div>
        </div>}
        <div className='alert'>
          <Alert message="代币燃烧为不可逆操作，请确认目的明确并已核对数量。执行后，代币将永久移出流通，错误操作可能造成经济损失。" type="warning" showIcon closable />
        </div>
        <button className='start-btn' onClick={startBurn}>确认燃烧</button>
      </div>
    </div>
  )
}
